export default __webpack_public_path__ + "static/media/photo--sm--misc-6.4ff6dc65.jpg";